import Vue from 'vue'
import { axiosInstance } from '@/assets/js/api/http'
import { addUrlParams } from '@/assets/js/utils/utils'

const axiosRequest = axiosInstance('CLOUD_URL')
const axiosRequestCom = axiosInstance('CLOUD_URL', true)

/**
 * 基础平台静态资源图片域名
 * @return {*}
 */
export const imageAuthHost = () =>
  `${Vue.prototype.$APP_CONFIG.AUTH_HOST}`

/**
 * 后端静态资源图片域名
 * @return {*}
 */
export const fileHost = () =>
  `${Vue.prototype.$APP_CONFIG.CLOUD_URL}`

/**
 * 退出登录地址URL
 * @params {string} url 回调地址
 * @return {*}
 */
export const logoutHost = url =>
  `${Vue.prototype.$APP_CONFIG.AUTH_HOST}/authApi/auth/logout?redirect_uri=${url}`

/**
 * getCountDataFromBigData
 * @params {object} params 参数
 * @return {*}
 */
export const getCountDataFromBigData = params =>
  axiosRequest.get('/bigData/getCountDataFromBigData', { params: params })

/**
 * queryUserBranchTeacher
 * @params {string} id id
 * @return {*}
 */
export const queryUserBranchTeacher = id =>
  axiosRequest.get(`/masterschool/checkMasterSchool/${id}`)

/**
 * checkMasterSchool
 * @params {string, number} schoolId 参数
 * @return {*}
 */
export const checkMasterSchool = schoolId =>
  axiosRequest.get(`/masterschool/checkMasterSchool/${schoolId}`)

/**
 * getTeacherLessonList
 * @params {object} params 参数
 * @return {*}
 */
export const getTeacherLessonList = params =>
  axiosRequest.post('/netschoolLesson/getTeacherLessonList', params)

/**
 * queryMasterSchoolByExample
 * @params {object} params 参数
 * @return {*}
 */
export const queryMasterSchoolByExample = params =>
  axiosRequest.post('/masterschool/getMasterSchoolByExample', params)

/**
 * getBranchTeacherLessonList
 * @params {object} params 参数
 * @return {*}
 */
export const getBranchTeacherLessonList = params =>
  axiosRequest.post('/netschoolLesson/getBranchTeacherLessonList', params)

/**
 * queryCourseList
 * @params {object} params 参数
 * @return {*}
 */
export const queryCourseList = () =>
  axiosRequest.get('/netSchoolCourse/findCourseNameForCode/xxjd_xiaoxue')

/**
 * getMasterSchoolBykey
 * @params {string, number} unionId 参数
 * @params {string, number} schoolId 参数
 * @return {*}
 */
export const getMasterSchoolBykey = (unionId, schoolId) =>
  axiosRequest.post(`/masterschool/getMasterSchoolBykey/${unionId}/${schoolId}`)

/**
 * findCourseNameForCode
 * @params {string, number} schoolStepCode 参数
 * @return {*}
 */
export const findCourseNameForCode = schoolStepCode =>
  axiosRequest.get(`/netSchoolCourse/findCourseNameForCode/${schoolStepCode}`)

/**
 * getEvaluationStandardList
 * @params {object} params 参数
 * @return {*}
 */
export const getEvaluationStandardList = params =>
  axiosRequest.post('/evaluationstanard/getEvaluationStandardList', params)

/**
 * getEvaluationElementList
 * @params {object} params 参数
 * @return {*}
 */
export const getEvaluationElementList = params =>
  axiosRequest.post('/evaluationstanard/getEvaluationElementList', params)

/**
 * getFileInfoByFileId
 * @params {string, number} fileId 参数
 * @return {*}
 */
export const getFileInfoByFileId = fileId =>
  axiosRequest.get(`/file/getFileInfoByFileId/${fileId}`)

/**
 * getNetschoolLessonByKey
 * @params {string, number} lessonId 参数
 * @return {*}
 */
export const getNetschoolLessonByKey = (lessonId, params = {}) =>
  axiosRequest.get(`/netschoolLesson/getNetschoolLessonByKey/${lessonId}`, { params: params })

/**
 * getNetschoolMasterLessonByExample
 * @params {object} params 参数
 * @return {*}
 */
export const getNetschoolMasterLessonByExample = params =>
  axiosRequest.post('/netschoolLesson/getNetschoolMasterLessonByExample/', params)

/**
 * saveNetschoolLesson
 * @params {object} params 参数
 * @return {*}
 */
export const saveNetschoolLesson = params =>
  axiosRequest.post('/netschoolLesson/saveNetschoolLesson', params)

/**
 * getLiveCourseList
 * @params {object} params 参数
 * @return {*}
 */
export const getLiveCourseList = params =>
  axiosRequest.get('/netschoolLesson/getLiveCourseList', { params: params })

/**
 * getEduLessonList
 * @params {object} params 参数
 * @return {*}
 */
export const getEduLessonList = params =>
  axiosRequest.post('/netschoolLesson/getEduLessonList', params)

/**
 * getUnionSchoolList
 * @params {object} params 参数
 * @return {*}
 */
export const getUnionSchoolList = params =>
  axiosRequest.post('/masterschool/getUnionSchoolList', params)

/**
 * deleteNetschoolLesson
 * @params {string, number} lessonId 参数
 * @return {*}
 */
export const deleteNetschoolLesson = lessonId =>
  axiosRequest.post(`/netschoolLesson/deleteNetschoolLesson/${lessonId}`)

/**
 * deleteMasterSchool
 * @params {string, number} uid 参数
 * @params {string, number} sid 参数
 * @return {*}
 */
export const deleteMasterSchool = (uid, sid) =>
  axiosRequest.get(`/masterschool/deleteMasterSchool/${uid}/${sid}`)

/**
 * queryProvince
 * @params {string, number} name 参数
 * @params {object} params 参数
 * @return {*}
 */
export const queryProvince = (name, params) =>
  axiosRequest.get(`/dicarea/${name}`, { params: params })

/**
 * saveMasterSchool
 * @params {object} params 参数
 * @return {*}
 */
export const saveMasterSchool = params =>
  axiosRequest.post('/masterschool/saveMasterSchool', params)

/**
 * queryEduZhiBoLessonList
 * @params {object} params 参数
 * @return {*}
 */
export const queryEduZhiBoLessonList = params =>
  axiosRequest.post('/netschoolLesson/getEduZhiBoLessonList', params)

/**
 * 获取上传文件token
 * @params {object} params 参数
 * @return {*}
 */
export const getFileToken = params =>
  axiosRequest.get('/file/getFileToken')

/**
 * 获取首页楼层资源
 * @return {*}
 */
export const queryFloor = () =>
  axiosRequest.get('/roleAndStorey/selectResourceInfo')

/**
 * 获取首页banner列表
 * @return {*}
 */
export const queryBanner = () =>
  axiosRequest.get('/banner/list')

/**
 * 获取导航栏菜单
 * @return {*}
 */
export const queryCloudMenu = () =>
  axiosRequest.get('/roleAndMenu/selectMenuInfo')

/**
 * 获取网络联校菜单
 * @return {*}
 */
export const queryNetworkMenu = () =>
  axiosRequest.get('/roleAndMenu/selectSubMenuInfo')

/**
 * 获取名校课堂、网络联校统计页日历数据
 * @params {object} params 参数
 * @return {*}
 */
export const getorgtable = params =>
  axiosRequest.post('/yunke/getorgtable1', params)

/**
 * getOrgTeacher
 * @params {object} params 参数
 * @return {*}
 */
export const getOrgTeacher = params =>
  axiosRequest.post('/yunke/getOrgTeacher', params)

/**
 * queryUserRegister
 * @params {object} params 参数
 * @return {*}
 */
export const queryUserRegister = params =>
  axiosRequest.post('/yunke/registration', params)

/**
 * registration
 * @params {object} params 参数
 * @return {*}
 */
export const registration = params =>
  axiosRequest.post('/yunke/registration', params)

/**
 * queryYunKeCourseList
 * @params {object} params 参数
 * @return {*}
 */
export const queryYunKeCourseList = params =>
  axiosRequest.post('/yunke/courseList', params)

/**
 * 返回跳转全部拼接后URL，用于跳转全部，后端重定向
 * @params {object} params 参数
 * @return {*}
 */
export const queryMoreUrl = params =>
  addUrlParams(`${Vue.prototype.$APP_CONFIG.CLOUD_URL}/yunke/jumpUrl`, params)

/**
 * 请求跳转全部，前端重定向
 * @params {object} params 参数
 * @return {*}
 */
export const queryMore = params =>
  axiosRequest.get('/yunke/yyxtJumpUrl', { params: params })

/**
 * 返回认证后跳转URL，用于跳转到其它平台
 * @params {string} url 参数
 * @params {string} title 参数
 * @return {*}
 */
export const routerPageUrl = (url, title) =>
  addUrlParams(Vue.prototype.$APP_CONFIG.YUNKE_URL, {
    title: title,
    url: window.encodeURIComponent(
      addUrlParams(Vue.prototype.$APP_CONFIG.AUTH_URL, {
        client_id: Vue.prototype.$APP_CONFIG.STATIC.aut_url_client_id,
        response_type: 'code',
        redirect_uri: window.encodeURIComponent(
          addUrlParams(Vue.prototype.$APP_CONFIG.AUTH_URL_, {
            response_type: 'code',
            client_id: Vue.prototype.$APP_CONFIG.STATIC.aut_url_client_id_,
            redirect_uri: window.encodeURIComponent(
              addUrlParams(
                Vue.prototype.$APP_CONFIG.YUNKE_URL_,
                {
                  url: window.encodeURIComponent(url),
                },
              ),
            ),
          }),
        ),
      }),
    ),
  })

/**
 * 获取用户信息
 * @params {string} code code
 * @return {*}
 */
export const queryUserInfo = code =>
  axiosRequest.get(`/login/userLogin/${code}`)

/**
 * 退出登录
 * @return {*}
 */
export const logoutUser = () =>
  axiosRequest.get('/login/logout')

/**
 * 查询统一认证登录状态
 * @return {*}
 */
export const queryIfLogin = () =>
  axiosRequest.post(`${Vue.prototype.$APP_CONFIG.AUTH_HOST}/authApi/auth/ifLogin`)

/**
 * getSchoolsByCondition
 * @params {object} params 参数
 * @return {*}
 */
export const getSchoolsByCondition = params =>
  axiosRequest.post('/base/getSchoolsByCondition', params)

/**
 * getTeachersByCondition
 * @params {object} params 参数
 * @return {*}
 */
export const getTeachersByCondition = params =>
  axiosRequest.get('/base/getTeachersByCondition', { params: params })

/**
 * queryDictListByDictType
 * @params {object} params 参数
 * @return {*}
 */
export const queryDictListByDictType = params =>
  axiosRequest.get('/dict/getDictListByDictType/1', { params: params })

/**
 * getDictListByDictType
 * @params {string, number} dictId 参数
 * @return {*}
 */
export const getDictListByDictType = dictId =>
  axiosRequest.get(`/dict/getDictListByDictType/${dictId}`)

/**
 * findStandardById
 * @params {string, number} standardId 参数
 * @return {*}
 */
export const findStandardById = standardId =>
  axiosRequest.get(`/lessonEvaluation/findStandardById/${standardId}`)

/**
 * saveLessonEvaluation
 * @params {object} params 参数
 * @return {*}
 */
export const saveLessonEvaluation = params =>
  axiosRequest.post('/lessonEvaluation/saveLessonEvaluation/', params)

/**
 * findEvaluationScore
 * @params {string, number} lessonId 参数
 * @return {*}
 */
export const findEvaluationScore = lessonId =>
  axiosRequest.get(`/lessonEvaluation/findEvaluationScore/${lessonId}`)

/**
 * 文件资源下载文件名
 * @params {object} params 参数
 * @return {*}
 */
export const downloadReName = params =>
  axiosRequestCom.post('/documentresource/downloadRename', null, {
    params: params,
    responseType: 'blob',
  })
